module.exports = __webpack_public_path__ + "static/media/pusheencat.50dbdbc4.png";